import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'profileImage'
})
export class ProfileImagePipe implements PipeTransform {
  constructor() {

  }

  transform(profileImageUrl: string | null | undefined): string {
    if (profileImageUrl && profileImageUrl !== '') {
      return profileImageUrl;
    }
    return 'assets/icons/icon-default-profile.png';
  }
}